
export default theme => {
  const { unit } = theme.spacing;
  const space = unit * 3;
  return {
    card: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: unit * 100,
      transform: 'translate(-50%, -50%)',
      overflow: 'auto',
    },
    icon: {
      marginRight: unit,
    },
    button: {
      marginLeft: 'auto',
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      padding: space,
    },
    textFieldContainer: {
      paddingRight: space,
      paddingBottom: space,
      paddingLeft: unit * 2,
    },
    formControl: {
      width: '45%',
      marginLeft: unit,
    },
    textField: {
      marginLeft: unit,
      marginRight: unit,
      width: '45%',
    },
    'textField-Full_Address': {
      width: '95%',
    },
    message: {
      margin: space,
      marginBottom: 0,
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/courses/components/AddCourse/styles.js